module.exports = __webpack_public_path__ + "static/media/filter.879bd935.svg";